import { Controller } from "@hotwired/stimulus"

// Copies a link and says so for a moment: <span data-controller="clipboard" data-clipboard-text-value="https://…">
export default class extends Controller {
  static values = { text: String }
  static targets = ["button", "status"]

  async copy() {
    try {
      await navigator.clipboard.writeText(this.textValue)
    } catch {
      window.prompt("Copy this link", this.textValue)
      return
    }
    clearTimeout(this.timer)
    this.buttonTarget.setAttribute("data-copied", "")
    this.buttonTarget.title = "Copied"
    if (this.hasStatusTarget) this.statusTarget.textContent = "Copied"
    this.timer = setTimeout(() => {
      this.buttonTarget.removeAttribute("data-copied")
      this.buttonTarget.title = "Copy link"
      if (this.hasStatusTarget) this.statusTarget.textContent = ""
    }, 1500)
  }

  disconnect() {
    clearTimeout(this.timer)
  }
}
